// Recharts gibi SVG tabanlı grafiklerde Tailwind class kullanılamaz —
// grafik eksen/grid/bar renkleri bu token'lardan alınır.
export const chartColors = {
  axis: "#475569", // slate-600
  grid: "#94a3b8", // slate-400
  bar: "#818cf8", // indigo-400
  neutral: "#94a3b8", // slate-400 — ürün rengi bulunamayınca fallback
  // Otomatik karıştırma eğrisi (Göz Ayarları)
  mixerBar: "#f59e0b", // amber-500
  mixerBarOff: "#d1d5db", // gray-300 — otomatik kapalıyken sönük
  mixerKnee: "#ca8a04", // yellow-600 — dirsek çizgisi
  // Fincan/değirmen sensörü zaman grafiği (Bakım → açıklama paneli)
  sensorValue: "#0f766e", // teal-700 — ham fark
  sensorThreshold: "#f59e0b", // amber-500 — eşik çizgisi
  // Askı sensörü zaman grafiği (Bakım → askı açıklama paneli)
  hangerDev: "#e11d48", // rose-600 — sapan örnek
  hangerFlat: "#0f766e", // teal-700 — düz örnek
  hangerDevLimit: "#fb7185", // rose-400 — sapan sınırı (7)
  hangerFlatLimit: "#2dd4bf", // teal-400 — düz sınırı (243)
};

// MUI sx alanlarında Tailwind class kullanılamaz — inline stiller bu
// token'lardan beslenir.
export const muiColors = {
  inputBg: "#f9fafb", // gray-50
  // Tarih seçicilerin ortak kabuğu (atoms/DateField) bu token'ları kullanır.
  // Daha önce 7 ayrı dosya kendi datePickerSx'ini tanımlıyor ve bu renkleri
  // hex olarak gömüyordu; tek kaynağa alındı.
  fieldBg: "#ffffff",
  fieldBorderHover: "#818cf8", // indigo-400
  fieldBorderFocus: "#6366f1", // indigo-500
};

export const colors = {
  primary: {
    main: "#8b5e34",
    light: "#d4a276",
    dark: "#6f4518",
    gradient: "from-[#8b5e34] to-[#d4a276]",
    gradientLight: "from-[#ffedd8]/60 to-transparent",
    border: "border-[#8b5e34]",
    text: "text-[#8b5e34]",
    hover: "hover:bg-[#8b5e34]",
    bg: "bg-[#8b5e34]",
    bgLight: "bg-[#ffedd8]",
    hoverBgLight: "hover:bg-[#f3d5b5]",
    hoverText: "hover:text-[#8b5e34]",
  },
  status: {
    success: {
      text: "text-green-600",
      bg: "bg-green-100",
    },
    error: {
      text: "text-red-600",
      bg: "bg-red-100",
    },
    warning: {
      text: "text-orange-500",
      bg: "bg-orange-100",
    },
    inactive: {
      text: "text-gray-600",
      bg: "bg-gray-100",
    },
  },
  text: {
    primary: "text-gray-800",
    secondary: "text-gray-700",
    tertiary: "text-gray-600",
    light: "text-gray-500",
    white: "text-white",
    whiteAlpha: "text-white/80",
  },
  background: {
    main: "bg-white",
    lighter: "bg-gray-50",
    light: "bg-gray-100",
    modal: "bg-gray-300",
    card: "bg-white",
  },
  border: {
    light: "border-gray-100",
    main: "border-gray-200",
  },
};
